import React, { useContext } from "react";
import { Nav } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import AppContext from "../../../context/Context";
import Logo from "../../common/Logo";
import ToggleButton from "./ToggleButton";
import logo from "../../../assets/img/illustrations/falcon.png";
import { Add, ExploreOutlined, LocalOfferOutlined, CleaningServices, WhatsApp, DarkModeOutlined, LightModeOutlined,  TouchAppOutlined, MemoryOutlined, WorkspacePremiumOutlined, PersonAddAlt1Outlined, HomeOutlined } from "@mui/icons-material";
import { getBrokerList } from "../../../redux/actions/brokerAction";
import { Menu } from "lucide-react";

const NavbarVertical = ({isMenuOpen, setIsMenuOpen}) => {
  const { config, setConfig } = useContext(AppContext);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const isDark = config?.isDark === true;
  
  const user = useSelector((state) => state.user);
  const loginStatus = {
    activeTradeSubscription: user?.activeTradeSubscription || false,
    brokerLoggedIn: user?.brokerLoggedIn || false,
    accounts: user?.accounts ?? 0,
    brokerList: user?.brokerList || []
  };

  const handleDiscover = () => {
    const href = window.location.href;
    const isBeta = href.includes("beta");
    let target;
    if(user.activeSubscription){
      target = isBeta ? "https://beta.fnotrader.com/pages/dashboard" : "https://fnotrader.com/pages/dashboard";
    }else{
      target = isBeta ? "https://beta.fnotrader.com/pricing" : "https://fnotrader.com/pricing";
    }
    window.open(target, "_blank"); 
  };

  const clearCache = () => {
    localStorage.clear();
    sessionStorage.clear();
    window.location.reload();
    setIsMenuOpen(false);
  };

  const toggleTheme = () => {
    setConfig("isDark", !config.isDark);
    setIsMenuOpen(false);
  };

  const openRefer = () => {
    navigate('/refer')
  };

  const openWhatsApp = () => {
    window.open("https://wa.me/918885635467", "_blank");
  };

  const handleQuikTradeManual = async () => {
    if(location.pathname === "/terminal"){
      return
    }
    navigate("/terminal")
    setIsMenuOpen(false);
  };

  const handleQuikTradeAlgo = async () => {

    if(location.pathname === "/algo/accounts"){
      return
    }
    navigate("/algo/accounts")
    setIsMenuOpen(false);
  };

  const SidebarItem = ({ icon: IconComponent, title, subtitle, onClick, active }) => {
    const activeBg = isDark ? 'rgba(144, 202, 249, 0.16)' : '#e7f3ff';
    const iconColor = active
      ? (isDark ? '#90caf9' : '#2c7be5')
      : (isDark ? '#adb5bd' : '#6c757d');
    const textColor = active
      ? (isDark ? '#e3f2fd' : '#0b5ed7')
      : (isDark ? '#dee2e6' : '#212529');
    return (
      <Nav.Item as="li" style={{ marginBottom: 6 }}>
        <div
          className="sidebar-item"
          onClick={onClick}
          role="button"
          style={{ backgroundColor: active ? activeBg : undefined, borderRadius: 6, paddingLeft: 8, paddingRight: 8 }}
        >
          <span>
            <IconComponent fontSize="small" sx={{ color: iconColor }} />
          </span>
          <div className="d-flex flex-column">
            <span style={{ fontSize: "10px", color: textColor }} className="fw-semibold">{title}</span>
          </div>
        </div>
      </Nav.Item>
    );
  };

  return (
    <nav className={`navbar-vertical ${isMenuOpen ? "open" : ""}`}>
      <div style={{ height: "47px" }} className="d-flex align-items-center justify-content-center">
        <Menu />
      </div>
      <Nav as="ul" className="flex-column px-2 py-2">
        <SidebarItem
          icon={HomeOutlined}
          title="Home"
          onClick={() => navigate("/home")}
          active={location.pathname === '/home'}
        />
        <SidebarItem
          icon={Add}
          title="Add Broker"
          onClick={() => navigate("/broker-login")}
          active={location.pathname === '/broker-login'}
        />
        <SidebarItem
          icon={TouchAppOutlined}
          title="Terminal"
          onClick={handleQuikTradeManual}
          active={location.pathname === '/terminal'}
        />
        <SidebarItem
          icon={MemoryOutlined}
          title="Algo Signals"
          onClick={handleQuikTradeAlgo}
          active={location.pathname.includes("algo")}
        />
        <SidebarItem
          icon={ExploreOutlined}
          title="Discover"
          onClick={handleDiscover}
        />
        <SidebarItem
          icon={LocalOfferOutlined}
          title="Pricing"
          onClick={() => {navigate("/pricing");
            setIsMenuOpen(false)}}
          active={location.pathname === '/pricing'}
        />
        <SidebarItem
          icon={WorkspacePremiumOutlined}
          title="Subscriptions"
          onClick={() => {navigate("/subscriptions");
            setIsMenuOpen(false)}}
          active={location.pathname === '/subscriptions'}
        />
        <SidebarItem
          icon={WhatsApp}
          title="WhatsApp"
          onClick={openWhatsApp}
        />
        <SidebarItem
          icon={CleaningServices}
          title="Clear Cache"
          onClick={clearCache}
        />
        <SidebarItem
          icon={config.isDark ? LightModeOutlined : DarkModeOutlined}
          title={config.isDark ? "Light Theme" : "Dark Theme"}
          onClick={toggleTheme}
        />
        <SidebarItem
          icon={PersonAddAlt1Outlined}
          title="Refer"
          onClick={openRefer}
          active={location.pathname === '/refer'}
        />
      </Nav>
    </nav>
  );
};

export default NavbarVertical;




